import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ContactInfo } from '../../models/project-info.types';

@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactDetailsComponent {
  readonly contact = input.required<ContactInfo>();
}
